import React, { useEffect } from 'react'
import Event11 from './eventImg/event-14-june-2.webp'


const Event14 = () => {
    useEffect(() => {
        document.title = "Distinguished Lecture on Energy Efficiency & Renewable Energy";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>14 June 2025</h1> 
<h3 className='text-center'>Distinguished Lecture on Energy Efficiency & Renewable Energy</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event11} alt='Distinguished Lecture on Energy Efficiency & Renewable Energy'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/bZKG57V5Bb4=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event14

